
import { useEffect } from 'react';
import { useMessage } from '@/shared/hooks/useMessage';
import { useGetPendingRequestsToApprove } from '@/shared/api/client/action-flow';
import type { ActionFlowRequestDTO, ActionFlowRequestSearch } from '@/shared/api/model';

/**
 * Hook to fetch pending action flow requests
 *
 * @param searchParams - Search parameters excluding status (status will be set to PENDING)
 * @returns Object containing pending requests data, loading state, error and refetch function
 */
export const usePendingRequests = (searchParams: ActionFlowRequestSearch) => {
    const message = useMessage();

    const {
        data: response,
        isLoading,
        error,
        refetch
    } = useGetPendingRequestsToApprove<ActionFlowRequestDTO[]>({ search: searchParams }, {
        query: {
            enabled: true
        }
    });

    useEffect(() => {
        if (error) {
            message.error('Failed to fetch pending requests');
        }
    }, [error, message]);

    const normalizedResponse = response as (ActionFlowRequestDTO[] & { data?: ActionFlowRequestDTO[] }) | undefined;
    const requests = normalizedResponse?.data ?? normalizedResponse ?? [];

    return {
        requests,
        isLoading,
        error,
        refetch
    };
};